/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BottomBannerDto } from '../../models/bottom-banner-dto';

export interface BottomBannerAdminControllerUpdateAllV1$Params {
      body: Array<string>
}

export function bottomBannerAdminControllerUpdateAllV1(http: HttpClient, rootUrl: string, params: BottomBannerAdminControllerUpdateAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BottomBannerDto>>> {
  const rb = new RequestBuilder(rootUrl, bottomBannerAdminControllerUpdateAllV1.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BottomBannerDto>>;
    })
  );
}

bottomBannerAdminControllerUpdateAllV1.PATH = '/api/v1/bottom-banners/admin';
